import { render, staticRenderFns } from "./ProjectsTracker.vue?vue&type=template&id=3fac6a74&scoped=true"
import script from "./ProjectsTracker.vue?vue&type=script&lang=js"
export * from "./ProjectsTracker.vue?vue&type=script&lang=js"
import style0 from "./ProjectsTracker.vue?vue&type=style&index=0&id=3fac6a74&prod&lang=css"
import style1 from "./ProjectsTracker.vue?vue&type=style&index=1&id=3fac6a74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fac6a74",
  null
  
)

export default component.exports